// import { useState, useCallback, useMemo } from 'react';
// import { useRequest } from 'ahooks';
// import { getThemeList } from '../../../axios/api'

// function useGetThemeList(){
//     const [editingMenuId, setEditingMenuId] = useState()
//     const [activeMenuId,setActiveMenuId] = useState()

//     const { loading, data, run } = useRequest(
//         async () => {
//           try {
//             const resp =  await getThemeList() 
//             let themeList = resp?.data?.theme_list
//             return themeList ?? [];
//           } catch (error) {
//             console.log(error)
//             // message.error('获取主题列表失败！');
//             return [];
//           }
//         },
//     );
//     const refresh = () => {
//       run()
//     };

//     return {
//         loading,
//         data,
//         refresh,
//         editingMenuId,
//         setEditingMenuId,
//         activeMenuId,
//         setActiveMenuId

//     }
// }

// export default useGetThemeList

import { useState, useCallback, useMemo ,useEffect} from 'react';
import { useRequest } from 'ahooks';
import { getThemeList } from '../../../axios/api'
import util from "../../../utils/utils";

function useGetThemeList(){
  
  const [editingMenuId, setEditingMenuId] = useState()
  const [activeMenuId,setActiveMenuId] = useState(util.getStorage('activeMenuId'))
  useEffect(()=>{
    if(activeMenuId){
      util.setStorage('activeMenuId',activeMenuId)

    }
  },[activeMenuId])

    const { loading, data, run } = useRequest(
        async () => {
          try {
            const resp =  await getThemeList() 
            let themeList = resp?.data?.theme_list
            return themeList ?? [];
          } catch (error) {
            console.log(error)
            // message.error('获取主题列表失败！');
            return [];
          }
        },
    );
    const refresh = () => {
      run()
    };

    return {
        loading,
        data,
        refresh,
        editingMenuId,
        setEditingMenuId,
        activeMenuId,
        setActiveMenuId

    }
}

export default useGetThemeList